import { render } from "./DeleteIcon.vue?vue&type=template&id=1548fb35&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"

import "./DeleteIcon.vue?vue&type=style&index=0&id=1548fb35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1548fb35"]])

export default __exports__